/* eslint-disable react/require-default-props */
import moment from 'moment';
import React from 'react';
import { useDispatch } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { updateUserChatMessage } from 'store/modules/chatbot_assistant_store/actions';
import { SpeechButton } from 'components/atoms/speech';
import { CurrentUserChatMessageTypes } from 'store/modules/chatbot_assistant_store/types';
import { BiddingChatMessageTypes } from 'store/modules/bidding_chat/types';
import { updateChatMessage } from 'store/modules/bidding_chat/actions';
import { Avatar, MarkdownContent } from './styles';

interface ChatbotMessageProps {
  message: CurrentUserChatMessageTypes | BiddingChatMessageTypes;
  source: 'chat' | 'history' | 'bidding_chat';
  firstMessage?: boolean;
}

const ChatbotMessage = (props: ChatbotMessageProps) => {
  const dispatch = useDispatch();
  const { message, source, firstMessage = false } = props;

  const rateMessage = (rating: boolean) => {
    if (source === 'chat') return dispatch(updateUserChatMessage(message.id || 0, rating));
    return dispatch(updateChatMessage(message.id || 0, rating));
  };

  const ratingClass = (rating: 'up' | 'down') => {
    if (message.rating === null) return '';
    if (rating === 'up' && [1, true].includes(message.rating)) return 'rated';
    if (rating === 'down' && [0, false].includes(message.rating)) return 'rated';
    return '';
  };

  return (
    <div className={`message ${message.role}`}>
      <div className="message-box">
        {message.role === 'user' && (
          <>
            <div className="message-author px-3 pt-3">
              <span className="font-weight-bold author-name">Você</span>
              <span className="material-icons author-avatar">account_circle</span>
            </div>
            <div
              className={`message-date text-right ${
                source === 'bidding_chat' ? 'p-0 pt-3 px-3 p-md-3' : 'px-3 pt-3'
              }`}
            >
              {source === 'bidding_chat' && (
                <>
                  {moment(message.created_at).format('DD/MM/YYYY')} <br />
                </>
              )}
              {moment(message.created_at).format('HH:mm')}
            </div>
          </>
        )}
        {message.role === 'assistant' && (
          <>
            <div className="message-author px-3 pt-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                  <div className="d-flex flex-column align-items-center">
                    <Avatar className="chatbot-avatar btn-ia">IA</Avatar>
                    {source === 'bidding_chat' && (
                      <SpeechButton
                        text={message.content}
                        variant="chat"
                        idleIcon="volume_up"
                        className="speech-chat-audio-outline mt-2"
                      />
                    )}
                  </div>
                  <span className="font-weight-bold author-name">Consultor Jurídico</span>
                </div>
              </div>
            </div>
            {!firstMessage && (
              <div
                className={`message-date text-right ${
                  source === 'bidding_chat' ? 'p-0 pt-3 px-3 p-md-3' : 'px-3 pt-3'
                }`}
                style={{
                  display: 'flex',
                  alignItems: source === 'bidding_chat' ? 'flex-start' : 'center',
                  justifyContent: 'flex-end',
                  gap: 6,
                }}
              >
                {source === 'chat' && (
                  <SpeechButton text={message.content} variant="chat" idleIcon="volume_up" />
                )}
                <span>
                  {source === 'bidding_chat' && (
                    <>
                      {moment(message.created_at).format('DD/MM/YYYY')} <br />
                    </>
                  )}
                  {moment(message.created_at).format('HH:mm')}
                </span>
              </div>
            )}
          </>
        )}
        <div className="message-text p-3">
          {firstMessage ? (
            <div dangerouslySetInnerHTML={{ __html: message.content }} />
          ) : (
            <MarkdownContent>
              <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                  a: ({ children, ...anchorProps }) => (
                    <a {...anchorProps} target="_blank" rel="noopener noreferrer">
                      {children}
                    </a>
                  ),
                }}
              >
                {message.content || ''}
              </ReactMarkdown>
            </MarkdownContent>
          )}

          {message.role === 'assistant' &&
            !firstMessage &&
            ['bidding_chat', 'chat'].includes(source) && (
              <div className="chatbot-rating pt-3">
                Essa resposta foi útil?
                <button
                  type="button"
                  className={`btn btn-chatbot btn-rating ${ratingClass('up')} btn-sm p-0 mx-2`}
                  onClick={() => rateMessage(true)}
                >
                  <span className="material-icons">thumb_up</span>
                </button>
                <button
                  type="button"
                  className={`btn btn-chatbot btn-rating ${ratingClass('down')} btn-sm p-0`}
                  onClick={() => rateMessage(false)}
                >
                  <span className="material-icons">thumb_down</span>
                </button>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default ChatbotMessage;
